<template>
  <link
    href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.0-beta1/dist/css/bootstrap.min.css"
    rel="stylesheet"
    integrity="sha384-0evHe/X+R7YkIZDRvuzKMRqM+OrBnVFBL6DOitfPri4tjfHxaWutUpFmBp4vmVor"
    crossorigin="anonymous"
  />

  <div class="frame">
    <timeModal :show="showModal"></timeModal>
    <div class="head">
      <img
        alt="Vue logo"
        @click="logOut()"
       src="../assets/mainLogo.png"
        height="250"
      />
    </div>
    <div class="main">
      <div>
        <table class="table leadertbl">
          <tr>
            <td>
              Show Top:<select
                class="numberShow"
                v-model="show"
                @change="onChange($event)"
                :disabled="isLoading"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="all">All</option>
              </select>
            </td>
            <td>
              <div>&nbsp;</div>
            </td>
            <td>
              <button
                class="btn btn-warning refreshbtn"
                @click="getScores()"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                {{ isLoading ? "Loading..." : "Refresh" }}
              </button>
            </td>
          </tr>
          <tr>
            <td>
              Start Date:<input
                type="date"
                class="numberShow"
                @change="onChangeStartDate($event)"
                :disabled="isLoading"
              />
            </td>
            <td>
              End Date:<input
                type="date"
                class="numberShow"
                @change="onChangeEndDate($event)"
                :disabled="isLoading"
              />
            </td>
            <td>
              <button
                class="btn btn-warning refreshbtn"
                @click="resetDate()"
                :disabled="isLoading"
              >
                Reset Date
              </button>
            </td>
          </tr>
        </table>
      </div>

      <!-- Loading overlay -->
      <div v-if="isLoading" class="loading-overlay">
        <div class="loading-spinner">
          <div class="spinner-border text-warning" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="loading-text mt-3">Loading scores...</p>
        </div>
      </div>

      <!-- Data table -->
      <table
        class="table leadertbl table-bordered"
        :class="{ 'loading-blur': isLoading }"
      >
        <thead>
          <th width="50px">#</th>
          <th>Team</th>
          <th>Time</th>
        </thead>
        <tbody>
          <template v-if="noScores === true && !isLoading">
            <tr>
              <td colspan="3">No Scores Recorded</td>
            </tr>
          </template>
          <template v-for="(game, index) in scores" :key="game._id || index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{ game.extra.teamname ||  game.extra.teamName || "Unknown Team" }}</td>
              <td>{{ formatGameTime(game) }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { callApi } from "../plugins/callApi.js";
import { DateTime } from "luxon";
const logo = require("../plugins/logo.js");
import timeModal from "./timeModal.vue";

export default defineComponent({
  name: "MessageApp",
  props: {},
  components: {
    timeModal,
  },
  data() {
    return {
      data: "",
      scores: "",
      noScores: false,
      show: 10,
      logoData: [],
      chosenCountry: "",
      startDate: 0,
      endDate: 0,
      timer: 0,
      showModal: false,
      editGame: [],
      chosenArea: "",
      isLoading: false,
    };
  },
  async mounted() {
    try {
      document.body.style.backgroundColor = "#000000";
      this.logoData = await logo.setup();
      await this.getScores();
    } catch (error) {
      console.error("Error during component initialization:", error);
    }
  },
  methods: {
    async update() {
      try {
        let gameTime = this.editGame.timeEdit;

        if ((gameTime.match(/:/g) || []).length === 1) {
          gameTime = "00:" + gameTime;
        }

        const arr = gameTime.split(":");
        const seconds =
          parseInt(arr[0]) * 3600 + parseInt(arr[1]) * 60 + parseInt(arr[2]);
        const newGameTime = this.timer - seconds;

        this.data = await callApi("leaderboard", {
          id: this.editGame._id,
          time: newGameTime,
        });

        this.showModal = false;
        await this.getScores();
      } catch (error) {
        console.error("Error updating game time:", error);
      }
    },

    close() {
      this.showModal = false;
    },

    formatGameTime(game) {
      try {
        if (
          !game ||
          typeof game["End"] === "undefined" ||
          typeof game.start === "undefined"
        ) {
          return "N/A";
        }

        const timeDiff = game["End"] - game.start;
        return this.secondstotime(timeDiff);
      } catch (error) {
        console.error("Error formatting game time:", error);
        return "Error";
      }
    },

    secondstotime(milliseconds) {
      try {
        if (isNaN(milliseconds) || milliseconds < 0) {
          return "00:00:00";
        }

        const date = new Date(null);
        date.setSeconds(milliseconds / 1000);
        return date.toISOString().substr(11, 8);
      } catch (error) {
        console.error("Error converting seconds to time:", error);
        return "00:00:00";
      }
    },

    fmtMSS(s) {
      if (isNaN(s) || s < 0) return "0:00";
      return Math.floor((s - (s %= 60)) / 60) + (9 < s ? ":" : ":0") + s;
    },

    logOut() {
      this.$parent.setup = false;
    },

    editTime(game) {
      try {
        this.editGame = { ...game };
        this.editGame.timeEdit = this.fmtMSS(this.timer - (game.timer || 0));
        this.showModal = true;
      } catch (error) {
        console.error("Error editing time:", error);
      }
    },

    onChangeStartDate(event) {
      try {
        this.startDate =
          DateTime.fromFormat(
            event.target.value + " 00:00",
            "yyyy-MM-dd hh:mm"
          ).toUnixInteger() * 1000;
        this.getScores();
      } catch (error) {
        console.error("Error setting start date:", error);
      }
    },

    onChangeEndDate(event) {
      try {
        this.endDate =
          DateTime.fromFormat(
            event.target.value + " 23:59",
            "yyyy-MM-dd hh:mm"
          ).toUnixInteger() * 1000;
        this.getScores();
      } catch (error) {
        console.error("Error setting end date:", error);
      }
    },

    resetDate() {
      this.startDate = 0;
      this.endDate = 0;
      this.getScores();
    },

    onChange(event) {
      this.show = event.target.value;
      this.getScores();
    },

    onChangeCountry(event) {
      this.chosenCountry = event.target.value;
      this.getScores();
    },

    async getScores() {
      if (this.isLoading) return;

      try {
        this.isLoading = true;

        const liceObj = localStorage.getItem('leaderBoardLicense');
        this.data = await callApi("leaderboard", liceObj);

        // Filter data to only include completed games with valid End and start times
        let filteredData = [];
        if (Array.isArray(this.data)) {
          filteredData = this.data.filter(
            (item) =>
              item &&
              typeof item["End"] !== "undefined" &&
              item["End"] !== null &&
              item["End"] !== "0" &&
              typeof item.start !== "undefined" &&
              item.start !== null
          );
        }

        // Apply country filtering if selected
        if (
          this.chosenCountry &&
          this.$parent?.gameData?.leaderboard?.countries?.[this.chosenCountry]
        ) {
          const langs =
            this.$parent.gameData.leaderboard.countries[this.chosenCountry];
          filteredData = filteredData.filter((score) =>
            langs.some((language) => score.chosenLanguage === language)
          );
        }

        // Apply date filtering if dates are set
        if (this.startDate !== 0 && this.endDate !== 0) {
          filteredData = filteredData.filter((dateScore) => {
            const scoreStart = dateScore.start || dateScore.TimerStart;
            return (
              scoreStart &&
              scoreStart > this.startDate &&
              scoreStart < this.endDate
            );
          });
        }

        this.data = filteredData;

        // Set scores based on show limit
        this.updateDisplayedScores();
      } catch (error) {
        console.error("Error fetching scores:", error);
        this.noScores = true;
        this.scores = [];
      } finally {
        this.isLoading = false;
      }
    },

    updateDisplayedScores() {
      if (!Array.isArray(this.data) || this.data.length === 0) {
        this.noScores = true;
        this.scores = [];
        return;
      }

      this.noScores = false;

      // Sort by completion time (End - start), fastest first (ascending order)
      const sortedData = [...this.data].sort((a, b) => {
        const timeA = a["End"] - a.start;
        const timeB = b["End"] - b.start;
        return timeA - timeB; // Ascending order (shortest/fastest time first)
      });

      if (this.show === "all") {
        this.scores = sortedData;
      } else {
        const limit = parseInt(this.show);
        this.scores = sortedData.slice(0, limit);
      }
    },
  },
});
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-spinner {
  text-align: center;
  color: #ffc107;
}

.loading-text {
  color: #ffc107;
  font-size: 1.1rem;
  font-weight: 500;
}

.loading-blur {
  filter: blur(2px);
  opacity: 0.6;
  transition: all 0.3s ease;
}

.main {
  position: relative;
}

/* Disabled state styles */
button:disabled,
select:disabled,
input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}
</style>